import { useState, useEffect, useRef } from "react";
import { toast } from "sonner";

export function useNetworkStatus() {
  // SSR-safe: on suppose "en ligne" au premier rendu (serveur + hydratation),
  // puis on lit navigator.onLine après le montage.
  const [isOnline, setIsOnline] = useState(true);
  const wasOffline = useRef(false);

  useEffect(() => {
    setIsOnline(typeof navigator === "undefined" ? true : navigator.onLine);

    const goOnline = () => {
      setIsOnline(true);
      if (wasOffline.current) {
        toast.success("Connexion rétablie ✓");
        wasOffline.current = false;
      }
    };
    const goOffline = () => {
      setIsOnline(false);
      wasOffline.current = true;
    };

    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  return isOnline;
}
